const resource = {

  ar: {
    translation: {

      ARABIC: "العربية",
      ENGLISH: "الانكليزية",
      Kurdish: "الكردية",
      ERADAT_TYPE: "نوع الايراد",
      Confirm_msg: "هل انت متأكد ؟ \n سوف يتم حذف \n",
      Home: "لوحة التحكم",
      TOTAL_QTY: "اجمالي الكمية",
      Setting: "الأعدادات",
      Branch: "الفروع",
      Report: "التقارير",
      Logout: "تسجيل الخروج",
      From_Date: "من تاريخ",
      To_Date: "الى",
      Download_Excel: "تحميل ملف اكسيل",
      BILL_NUMBER: "رقم الفاتورة",
      PASSWORD: "كلمة المرور",
      USER_NAME: "اسم المستخدم",
      JOB_DATE: "تاريخ الفترة",
      Time: "الوقت",
      Invoice_No: "رقم الفاتورة",
      Order_No: "رقم الطلب",
      Invoice_Amo: "مبلغ القائمة",
      Permissions: "الصلاحيات",
      Original_invoice: "اصل الفاتورة",
      Screen: "الشاشة",
      TOTAL_ORDERS: "مجموع الطلبات",
      Employee: "المستخدم",
      TOTAL_SALES: "مجموع اجمالي الطلبات",
      SELECT_BRANCH: "الفروع",
      DATE: "التاريخ",
      OPERATION: "العملية",
      CLIENT_NAME: "اسم العميل",
      TOT_QTY: "الكمية",
      PERMISSION_ALL: "كل الصلاحيات",
      SELL: "السعر",
      SHOW_ALL_INVOICE: "اظهار كل الفواتير",
      TOT_SALES: "الاجمالي",
      ITEMS_SALES_REPORT: "تقرير مبيعات المنتجات",
      CATEGORY_SALES_REPORT: "تقرير مبيعات المجموعات",
      ITEMS_REPORTS: "تقارير المنتجات",
      SALES_REPORT_FOR: "تقارير المبيعات لمدة",
      SALES_REPORT: "تقارير المبيعات",
      INVOICE_SALES: "فواتير المبيعات",
      SALES_REPORT_HOURLY: "تقرير المبيعات بالساعة",
      SALES_REPORT_DAY: "تقرير المبيعات اليومية",
      SALES_REPORT_MONTH: "تقرير المبيعات الشهرية",
      SALES_REPORT_DAY_WEEK: "تقرير المبيعات ايام الاسبوع",
      IVC_SALES_REORT: "تقرير مبيعات نقدي - أجل",
      ERADAT_REPORT: "تقرير الايرادات",
      EXPENSES_REPORT: "تقرير المصاريف",
      DAY_WEEK: "ايام الاسبوع",
      SALES_REPORT_YEARLY_QUARTERLY: "تقرير المبيعات ربع السنوية",
      SALES_REPORT_YEAR: "تقرير المبيعات السنوي",
      INVOICE_TYPE_REPORT: "تقرير انواع المبيعات",
      YEARLY_QUARTERLY: "الربع السنوي",
      INVOICE_FINAL_SALES_REPORT: "تقرير المبيعات الشامل",
      STORE_Report: "تقرير المخازن",
      ITEM_STORE_Report: "تقرير رصيد المنتجات",
      QTY_IN: "الكمية المدخلة",
      QTY_OUT: "الكمية المباعة",
      QTY_REMAIN: "الكمية المتبقية",
      TOTAL_QTY_IN: "اجمالي الكمية المدخلة",
      TOTAL_QTY_OUT: "اجمالي الكمية المباعة",
      TOTAL_QTY_REMAIN: "اجمالي الكمية المتبقية",
      HOUR: "الساعة",
      YEAR: "السنة",
      ITEM_NAME: "اسم المنتج",
      DISCOUNT_SELL: "الخصم",
      SERVICE_SELL: "الخدمة",
      TOTAL_DISCOUNT_SELL: "اجمالي الخصم",
      CATEGORY_NAME: "المجموعة",
      PERCENTAGE: "النسبة",
      NOTE: "التفاصيل",
      EXP_TYPE: "نوع الصرف",
      TOTAL_AMO: "المبلغ",
      TOTAL_AMO_ALL: " اجمالي المبلغ",
      TOTAL_OPERATIONS: "عدد العمليات",
      TOT_SELL: "اجمالي المبيعات",
      ERADAT: "الايرادات",
      TOTAL_ERADAT: "اجمالي الايرادات",
      ALL_DISCOUNT_SELL: "اجمالي الخصم",
      ALL_SERVICE_SELL: "اجمالي الخدمة",
      EXPENSES: "المصاريف",
      TOTAL_EXPENSES: "اجمالي المصاريف",
      NET_NET_SALES: "صافي المبلغ",
      MONTH: "الشهر",
      TYPE: "النوع",
      Monitor_Screen_Report: "تقرير شاشة المراقبة",
      Monitor_Screen: "شاشة المراقبة",
      Empty_Data: "لا يوجد بيانات",
      Deletion_And_Monitor_Report: "تقرير المحذوفات والمراقبة",
      Max_Date: "مشاهدة التقارير لاخر عدد ايام",
      SALES: " المبيعات",
      TOTAL_Discount: " الخصومات",
      SERVICE: " الخدمة",
      TOTAL_SERVICE: " الخدمة",
      NET_TOTAL: "صافي المبيعات",
      ORDER_TOTAL: "عدد الطلبات",
      SALES_BY_USERS: "المبيعات حسب المستخدمين",
      save: "حفظ",
      Edit: "تعديل",
      Delete: "حذف",
      Search: "بحث",
      Welcome: "تسجيل دخول",
      Email_Input: "ادخل الايميل",
      Password_Input: "ادخل كلمة المرور",
      Error_Login: "الايميل او كلمة المرور غير صحيحة",
      Login_Btn: "تسجيل الدخول",
      User_Report: "تقارير المستخدمين",
      ORDERS_USERS_REPORT: "فواتير مستخدمين",
      INVOICE_USERS_REPORT: "مبيعات مستخدمين",
      Next_Page: "الصفحة القادمة",
      From_Page: "من الصفحة",
      RowIn_Page: "عدد الاسطر في الصفحة",
      Preview_Page: "الصفحة السابقة",
      NoData_Page: "لا توجد بيانات",
      ShowColumn: "اظهار الاعمدة",
      Sort: "ترتيب",
      Branch_Name: "اسم الفرع",
      Branch_Code: "كود الفرع",
      USERS: "مستخدمين",
      USERS_PERMISSIONS: "صلاحيات المستخدمين",


      BRANCH_SALES_BY_SERVICE: "مبيعات الفروع حسب الخدمة",
      BRANCH_SALES_BY_MONTH: "مبيعات الفروع حسب الشهر",
      January: "يناير",
      February: "فبراير",
      March: "مارس",
      April: "أبريل",
      May: "مايو",
      June: "يونيو",
      July: "يوليو",
      August: "أغسطس",
      September: "سبتمبر",
      October: "أكتوبر",
      November: "نوفمبر",
      December: "ديسمبر",
      APP_NAME: "اسم التطبيق",
      TOT_APP: "مبلغ التطبيقات",
      NET_SALES: "اجمالي المبلغ",
      TOTAL_TOT_APP: "اجمالي التطبيق",
      APPLICATION_SALES: "تقرير مبيعات التطبيقات",
      CAPTIN_SALES: "تقرير مبيعات الكابتن",
      CAPTIN_NAME: "اسم الكابتن",
      TOTAL_SALES_CAPTIN: "اجمالي مبيعات الكابتن",


      SALES_DELIVERY_RETURN: "تقرير فواتير الراجع ديليفري",
      INVOICE_NAME: "نوع الطلب",
      NOTE_RESON: "سبب الراجع",
      CLIENT_PHONE: "رقم الهاتف",
      CLIENT_ADDRESS: "العنوان",
      QTY: "العدد",
      INVOICE_DETAILS: "تفاصيل الفاتورة",
      VIEW_DETAILS: "عرض التفاصيل",
    },
  },

  en: {
    translation: {

      ARABIC: "ARABIC",
      ENGLISH: "ENGLISH",
      Kurdish: "KURDISH",
      ERADAT_TYPE: "ERADAT TYPE",

      Confirm_msg: "ARE YOU SURE? \nIT WILL BE DELETED\n",
      Home: "CONTROL PANEL",
      Setting: "SETTINGS",
      Branch: "BRANCH",
      Report: "REPORTS",
      Logout: "LOG OUT",
      From_Date: "FROM DATE",
      To_Date: "TO",
      Download_Excel: "DOWNLOAD EXCEL FILE",
      BILL_NUMBER: "BILL NUMBER",
      PASSWORD: "PASSWORD",
      USER_NAME: "USER NAME",
      JOB_DATE: "JOB DATE",
      Time: "TIME",
      Invoice_No: "INVOICE NO.",
      Order_No: "ORDER NO.",
      Invoice_Amo: "INVOICE AMOUNT",
      Permissions: "PERMISSION",
      Original_invoice: "ORIGINAL INVOICE",
      Screen: "SCREEN",
      TOTAL_ORDERS: "TOTAL ORDERS",
      Employee: "USER",
      TOTAL_SALES: "TOTAL ORDERS",
      SELECT_BRANCH: "BRANCHS",
      DATE: "DATE",
      OPERATION: "OPERATION",
      CLIENT_NAME: "CLIENT NAME",
      TOT_QTY: "BALANCE",
      PERMISSION_ALL: "ALL PERMISSION",
      SELL: "PRICE",
      SHOW_ALL_INVOICE: "SHOW ALL INVOICE",
      TOT_SALES: "TOTAL",
      ITEMS_SALES_REPORT: "PRODUCT SALES REPORT",
      CATEGORY_SALES_REPORT: "CATEGORY SALES REPORT",
      ITEMS_REPORTS: "PRODUCT REPORT",
      SALES_REPORT_FOR: "SALES REPORT FOR",
      SALES_REPORT: "SALES REPORT",
      INVOICE_SALES: "INVOICE REPORT",
      SALES_REPORT_HOURLY: "HOURLY SALES REPORT",
      SALES_REPORT_DAY: "DAYS SALES REPORT",
      SALES_REPORT_MONTH: "MONTH SALES REPORT",
      SALES_REPORT_DAY_WEEK: "DAY OF WEEK SALES REPORT",
      IVC_SALES_REORT: "CASH - CREDIT SALES REPORT",
      ERADAT_REPORT: "ERADAT REPORT",
      EXPENSES_REPORT: "EXPENSES REPORT",
      DAY_WEEK: "DAYS OF THE WEEK",
      SALES_REPORT_YEARLY_QUARTERLY: "QUARTERLY YEAR SALES REPORT",
      SALES_REPORT_YEAR: "YEAR SALES REPORT",
      INVOICE_TYPE_REPORT: "SALES TYPE REPORT",
      YEARLY_QUARTERLY: "YEARLY QUARTERLY",
      INVOICE_FINAL_SALES_REPORT: "COMPREHENSIVE SALES REPORT",
      STORE_Report: "STORE REPORT",
      ITEM_STORE_Report: "STORE BALANCE REPORT",
      QTY_IN: "INPUT BALANCE",
      QTY_OUT: "BALANCE SOLD",
      QTY_REMAIN: "BALANCE REMAIN",
      TOTAL_QTY_IN: "TOTAL INPUT BALANCE",
      TOTAL_QTY_OUT: "TOTAL BALANCE SOLD",
      TOTAL_QTY_REMAIN: "TOTAL BALANCE REMAIN",
      HOUR: "HOUR",
      YEAR: "YEAR",
      ITEM_NAME: "ITEM NAME",
      DISCOUNT_SELL: "DISCOUNT",
      SERVICE_SELL: "SERVICE",
      TOTAL_DISCOUNT_SELL: "TOTAL DISCOUNT",
      CATEGORY_NAME: "CATEGORY",
      PERCENTAGE: "PERCENTAGE",
      NOTE: "DETAILS",
      EXP_TYPE: "EXCHANGE TYPE",
      TOTAL_AMO: "AMOUNT",
      TOTAL_QTY: "TOTAL QTY",
      TOTAL_AMO_ALL: "TOTAL AMOUNT",
      TOTAL_OPERATIONS: "TOTAL OPERATIONS",
      TOT_SELL: "TOTAL SALES",
      ERADAT: "ERADAT",
      TOTAL_ERADAT: "TOTAL ERADAT",
      ALL_DISCOUNT_SELL: "TOTAL DISCOUNTS",
      ALL_SERVICE_SELL: "TOTAL SERVICE",
      EXPENSES: "EXPENSES",
      TOTAL_EXPENSES: "TOTAL EXPENSES",
      NET_NET_SALES: "NET AMOUNT",
      MONTH: "MONTH",
      TYPE: "TYPE",
      Monitor_Screen_Report: "MONITOR SCREEN REPORT",
      Monitor_Screen: "MONITOR SCREEN",
      Empty_Data: "NO DATA",
      Deletion_And_Monitor_Report: "DELETION AND MONITOR REORTS",
      Max_Date: "VIEW REPORTS FOR THE LAST NUMBER OF DAYS",
      SALES: "SALES",
      TOTAL_Discount: " DISCOUNTS",
      SERVICE: "SERVICE",
      TOTAL_SERVICE: " SERVICE",
      NET_TOTAL: "NET SALES",
      ORDER_TOTAL: "TOTAL ORDER",
      SALES_BY_USERS: "SALES BY USERS",
      save: "SAVE",
      Edit: "EDIT",
      Delete: "DELETE",
      Search: "SEARCH",
      Welcome: "LOGIN",
      Email_Input: "ENTER EMAIL",
      Password_Input: "ENTER PASSWORD",
      Error_Login: "EMAIL OR PASSWORD IS INCORRECT",
      Login_Btn: "LOGIN",
      User_Report: "USERS REPORT",
      ORDERS_USERS_REPORT: "USERS INVOICES",
      INVOICE_USERS_REPORT: "USERS SALES",
      Next_Page: "NEXT PAGE",
      From_Page: "FROM PAGE",
      RowIn_Page: "COUNT ROWS IN PAGE",
      Preview_Page: "PREVIEW PAGE",
      NoData_Page: "NO DATE",
      ShowColumn: "SHOW COLUMN",
      Sort: "SORT",
      Branch_Name: "BRANCH NAME",
      Branch_Code: "BRANCH CODE",
      USERS: "USERS",
      USERS_PERMISSIONS: "USERS PERMISSION",
      BRANCH_SALES_BY_SERVICE: "BRANCH SALES BY SERVICE",

      January: "January",
      February: "February",
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",

      APP_NAME: "APP NAME",
      TOT_APP: "TOTAL APPS",
      NET_SALES: "NET SALES",
      TOTAL_TOT_APP: "TOTAL APP",
      APPLICATION_SALES: "APPLICATION SALES REPORT",

      CAPTIN_SALES: "CAPTIN SALES REPORT",
      CAPTIN_NAME: "CAPTIN NAME",
      TOTAL_SALES_CAPTIN: "TOTAL SALES CAPTIN",



      SALES_DELIVERY_RETURN: "SALES DELIVERY RETURN REPORT",
      INVOICE_NAME: "ORDER TYPE",
      NOTE_RESON: "NOTE REASON",
      CLIENT_PHONE: "PHONE NUMBER",
      CLIENT_ADDRESS: "ADDRESS",
      QTY: "QTY",
      INVOICE_DETAILS: "INVOICE DETAILS",
      VIEW_DETAILS: "VIEW DETAILS",

    },
  },

  ku: {
    translation: {
      ARABIC: "عه‌ره‌بی",
      ENGLISH: "ئینگلیزی",
      Kurdish: "کوردی",
      ERADAT_TYPE: "جۆری هەموار",
      Confirm_msg: "دڵنیایت؟ ئەم داتا دەسڕێتەوە",
      Home: "پەڕەی بەرێوەبردن",
      TOTAL_QTY: "کۆی گشتیی ژمارە",
      Setting: "ڕێکخستن",
      Branch: "لقەکان",
      Report: "راپۆرتەکان",
      Logout: "چوونه‌دەرەوه‌",
      From_Date: "له‌ مێژو",
      To_Date: "بۆ مێژو",
      Download_Excel: "داگرتنی فایل ئەکسل",
      BILL_NUMBER: "ژمارەی وەسڵ",
      PASSWORD: "تیپەرەوشە",
      USER_NAME: "ناوی ناوی بەکارهێنەر",
      JOB_DATE: "بەرواری کار",
      Time: "کات",
      Invoice_No: "ژمارەی وەسڵ",
      Order_No: "ژمارەی داوا",
      Invoice_Amo: "نرخی وەسڵ",
      Permissions: "مەفەکان",
      Original_invoice: "وەسڵی سەرەکی",
      Screen: "شاشە",
      TOTAL_ORDERS: "کۆی داواکاری",
      Employee: "بەکارهینەر",
      TOTAL_SALES: "کۆی گشتی داوەکاری",
      SELECT_BRANCH: "لقەکان",
      DATE: "بەروار",
      OPERATION: " پرۆسە",
      CLIENT_NAME: "ناوی كڕیار",
      TOT_QTY: "ژمارەی",
      PERMISSION_ALL: "هەموو مۆهەفەكانى",
      SELL: "نرخ",
      SHOW_ALL_INVOICE: "هەموو وەسڵەکان پیشان بدە",
      TOT_SALES: "کۆی گشتی",
      ITEMS_SALES_REPORT: "راپۆرتی فرۆشتنی بەرهەمەکان",
      CATEGORY_SALES_REPORT: "راپۆرتی فرۆشتنی گرووپەکان",
      ITEMS_REPORTS: "راپۆرتی بەرهەمەکان",
      SALES_REPORT_FOR: "راپۆرتی فرۆشتن بۆماوەی",
      SALES_REPORT: "راپۆرتی فرۆشتن",
      INVOICE_SALES: "وەسڵەکانی فرۆشتن",
      SALES_REPORT_HOURLY: "راپۆرتی فرۆشتن بە کاتژمێر",
      SALES_REPORT_DAY: "راپۆرتی فرۆشتنی ڕۆژانە",
      SALES_REPORT_MONTH: "راپۆرتی فرۆشتنی مانگانە",
      SALES_REPORT_DAY_WEEK: "راپۆرتی فرۆشتن  بە ڕۆژەکانی هەفتە",
      IVC_SALES_REORT: "فرۆشتنی نقد و قەرز",
      ERADAT_REPORT: "راپۆرتی دهەموارکان",
      EXPENSES_REPORT: "راپۆرتی خەرجی",
      DAY_WEEK: "ڕۆژەکانی هەفتە",
      SALES_REPORT_YEARLY_QUARTERLY: "راپۆرتی فرۆشتنى چارەکی ساڵانە ",
      SALES_REPORT_YEAR: "راپۆرتی  فرۆشتنی ساڵانە",
      INVOICE_TYPE_REPORT: "راپۆرتی جۆرەکانی فروشتن ",
      YEARLY_QUARTERLY: "چارەکی سالان",
      INVOICE_FINAL_SALES_REPORT: "راپۆرتی فرۆشتنی گشتی",
      STORE_Report: "راپۆرتی کۆگا",
      ITEM_STORE_Report: "راپۆرتی پاشەکەوتی بەرهەمەکان",
      QTY_IN: "ژمارەی داخڵکراو",
      QTY_OUT: "ژمارەی فرۆشراو",
      QTY_REMAIN: "ژمارەی ماوە",
      TOTAL_QTY_IN: "کۆی ژمارەی داخڵکراو",
      TOTAL_QTY_OUT: "کۆی ژمارەی فرۆشراو",
      TOTAL_QTY_REMAIN: "کۆی ژمارەی ماوە",
      HOUR: "کات",
      YEAR: "ساڵ",
      ITEM_NAME: "ناوی بەرهەم",
      DISCOUNT_SELL: "داشکاندن",
      SERVICE_SELL: "خزمەت",
      TOTAL_DISCOUNT_SELL: "کۆی داشکاندن",
      CATEGORY_NAME: "گرووپ",
      PERCENTAGE: "ڕێژە",
      NOTE: "وردەکاری",
      EXP_TYPE: "جۆری پارەدان",
      TOTAL_AMO: "پارە",
      TOTAL_AMO_ALL: "کۆی گشتی ",
      TOTAL_OPERATIONS: "ژمارەی کردارەکان",
      TOT_SELL: "کۆی  فرۆشتن",
      ERADAT: "هەمواری",
      TOTAL_ERADAT: "کۆی هەمواری",
      ALL_DISCOUNT_SELL: "کۆی داشکاندنەکان",
      ALL_SERVICE_SELL: "کۆی خزمەتەکان",
      EXPENSES: "خەرجی",
      TOTAL_EXPENSES: "کۆی خەرجی",
      NET_NET_SALES: "پاکی پارە",
      MONTH: "مانگ",
      TYPE: "جۆر",
      Monitor_Screen_Report: "راپۆرتی چاودێری",
      Monitor_Screen: "شاشەی چاودێری",
      Empty_Data: "هیچ زانيارىەک نیە",
      Deletion_And_Monitor_Report: "راپۆرتی سڕینەوە و چاودێری",
      Max_Date: "بينينی راپۆرتەکان بو كوتا ژمارەی روژەکان",
      SALES: "خزمەت",
      TOTAL_Discount: "کۆی داشکاندن",
      SERVICE: "خزمەت",
      TOTAL_SERVICE: " خزمەت",
      NET_TOTAL: "سەرەکی فرۆشتن",
      ORDER_TOTAL: "ژمارەی داواکان",
      SALES_BY_USERS: "فرۆشتن بەپێی بەکارهێنەران",
      save: "پاشەکەوت",
      Edit: "گۆڕان",
      Delete: "سڕینەوە",
      Search: "گەڕان",
      Welcome: "چوونەژوورەوە",
      Email_Input: "ئیمەیڵ بنووسە",
      Password_Input: "تێپەڕەوشەکە بنووسە",
      Error_Login: "ئيمەيڵ يان تێپەڕەوشە هەڵەیە",
      Login_Btn: "چوونە ژوورەوە",
      User_Report: "راپۆرتی بەکارهێنەران",
      ORDERS_USERS_REPORT: "بيلى بەکارهێنەران",
      INVOICE_USERS_REPORT: "فرۆشتی بەکارهێنەران",
      Next_Page: "لاپەڕەی دواتر ",
      From_Page: "لە لاپەڕە",
      RowIn_Page: "ژمارەی هێڵەکان لەپەرە",
      Preview_Page: "لاپەڕەی پێشوو",
      NoData_Page: "هیچ زانیاریەک نیە",
      ShowColumn: "پیشاندانی ستوونەکان",
      Sort: "رێزکردن",
      Branch_Name: "ناوی لق",
      Branch_Code: "کۆدی لق",
      USERS: "بەکارهێنەران",
      USERS_PERMISSIONS: "مەفەکانی بەکارهێنەران",


      BRANCH_SALES_BY_SERVICE: "فرۆشی شاخەکان بە پێی خزمەتگوزاری",
      BRANCH_SALES_BY_MONTH: "فرۆشی شاخەکان بە مانگ",

      January: "کانونی یەکەم",
      February: "شوبات",
      March: "ئازار",
      April: "نیسان",
      May: "ئایار",
      June: "حوزەیران",
      July: "تەمووز",
      August: "ئاب",
      September: "ئەیلوول",
      October: "تشرینی یەکەم",
      November: "تشرینی دووەم",
      December: "کانونی دووەم",

      APP_NAME: "ناوی ئەپ",
      TOT_APP: "کۆی داشكردنەوە",
      NET_SALES: "فرۆشتنی خالص",
      TOTAL_TOT_APP: "کۆی داشكردنەوەی گشتی",
      APPLICATION_SALES: "ڕاپۆرتی فرۆشی ئەپەکان",

      CAPTIN_SALES: "فرۆشتنی کۆپتین",
      CAPTIN_NAME: "ناوی کۆپتین",
      TOTAL_SALES_CAPTIN: "کۆی داشكردنەوەی گشتی",


      SALES_DELIVERY_RETURN: "فرۆشتنی دەلیوەکان و سەرەکان",
      INVOICE_NAME: "ناوی فرۆشتن",
      NOTE_RESON: "سەرەکەی سەرەکەی کۆپتین",
      CLIENT_PHONE: "شەمەرەی کۆپتین",
      CLIENT_ADDRESS: "ناوی کۆپتین",
      QTY: "کۆی داشكردنەوە",
      INVOICE_DETAILS: "زانیاریەکانی فرۆشتن",
      VIEW_DETAILS: "ڕاپۆرتی زانیاریەکانی فرۆشتن",

    }
  }
};

export default resource;
